import clsx from "clsx";
import logo from "../../../../public/img/sw-logo.svg";
import SidebarMenu from "./sidebar-menu.jsx";
import SidebarShortcuts from "./sidebar-shortcuts.jsx";
import {FaSearch} from "react-icons/fa";
import Button from "../../../components/button/button.jsx";
import InputForm from "../../../components/input/input-form.jsx";

const Sidebar = ({menu, shortcuts, collapsed, onToggle, onOpenSearch, badges}) => (
    <nav
        className={clsx(
            "mdb-sidebar fixed top-0 left-0 z-[1009] flex flex-col overflow-hidden",
            collapsed ? "h-[53px] w-[120px]" : "bottom-0 w-[220px]",
        )}
        role="navigation"
    >
        <button
            type="button"
            onClick={onToggle}
            title={collapsed ? "Expandir menu" : "Recolher menu"}
            className={clsx(
                "flex items-center justify-center w-full shrink-0 bg-transparent border-0 cursor-pointer",
                collapsed ? "h-[53px] p-2" : "h-[100px]",
            )}
        >
            <img src={logo} alt="Sentry" className={clsx("h-auto", collapsed ? "max-w-[100%]" : "max-w-[80%]")} />
        </button>

        {!collapsed && (
            <>
                <div className="flex items-center px-[15px] pb-2">
                    <div className="flex w-full cursor-pointer" onClick={onOpenSearch}>
                        <InputForm
                            classNameWrapper={"w-full pointer-events-none"}
                            inputClass={"bg-[#001327]! border-[#303030]! border-r-0! rounded-r-none! placeholder:text-white cursor-pointer"}
                            placeholder={"Pesquisar (Alt+2)"}
                            readOnly
                        />

                        <Button className={"w-9! rounded-l-none! p-1!"} target={"attached"} onClick={onOpenSearch}>
                            <FaSearch />
                        </Button>
                    </div>
                </div>

                <SidebarMenu menu={menu} badges={badges} />

                {shortcuts.length > 0 && <SidebarShortcuts shortcuts={shortcuts} badges={badges} />}
            </>
        )}
    </nav>
);

export default Sidebar;
